module.exports = __webpack_public_path__ + "img/pano-field-level.23c0fbdf.jpg";